import { useState } from 'react';

export const useRachelRegions = () => {
  const [footerSlotNode, setFooterSlotNode] = useState<HTMLDivElement | null>(null);

  return { footerSlotNode, setFooterSlotNode };
};
